import _isEqual from "lodash/isEqual";
import _isNil from "lodash/isNil";
import { analysisTools } from 'const';
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import getAnalysisTool from 'redux/selectors/getAnalysisTool';
var getIsSeuratSelector = function getIsSeuratSelector() {
  return function (analysisTool) {
    if (_isNil(analysisTool)) return null;
    return _isEqual(analysisTool, analysisTools.SEURAT);
  };
};
export default createMemoizedSelector(getIsSeuratSelector, {
  inputSelectors: getAnalysisTool()
});